// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EePc","tabsBox":"styles_tabsBox__2xUsK","createButton":"styles_createButton__2S9sq"};